import React from 'react';
import {
  Box,
  Heading,
  ProgressDetails,
  RichText,
  Skeleton,
  Stack,
  SubpageHeroSitecore,
  TopTasksSitecore,
} from '../../components';

import { SingleTopTaskInnerProps } from '../../types';

type ProgressHeroProps = {
  status?: string;
  title: string;
  detailTitle: string;
  detailDescription: string;
  topTasks?: SingleTopTaskInnerProps[];
  statusOptions: string[];
  image?: React.ReactElement;
  explanation: React.ReactElement;
  progressLink?: React.ReactElement;
  isLoading?: boolean;
};

export function ProgressHero(props: ProgressHeroProps) {
  const {
    detailDescription,
    detailTitle,
    explanation,
    progressLink,
    image,
    status,
    statusOptions,
    title,
    topTasks,
    isLoading,
  } = props;

  return (
    <SubpageHeroSitecore
      text={
        isLoading ? (
          <Stack direction="column" gap={2} isFullWidth>
            <Skeleton.Item width="85%" height="48px" />
            <Skeleton.Item width="70%" height="48px" />
          </Stack>
        ) : (
          <Stack direction="column" alignY={'end'} isFullHeight isFullWidth>
            <Heading size="h1">{title}</Heading>
          </Stack>
        )
      }
      tasks={
        topTasks && status ? (
          <TopTasksSitecore
            tasks={topTasks}
            variableBlock={
              <Box
                bg="containerLight"
                paddingTop={{ initial: 10, md: 14 }}
                paddingBottom={{ initial: 8, md: 10 }}
                paddingLeft={{ initial: 10, md: 16 }}
                paddingRight={{ initial: 10, md: 12 }}
                asChild
              >
                <Stack alignX="start" gap={4} alignY="justify" isFullHeight>
                  <Box width="100%">
                    {detailTitle ? (
                      <Box paddingBottom={4}>
                        {isLoading ? (
                          <Stack direction="column" gap={2}>
                            <Skeleton.Item width="90%" height="28px" />
                            <Skeleton.Item width="60%" height="28px" />
                          </Stack>
                        ) : (
                          <Heading size="h4" as="h2">
                            {detailTitle}
                          </Heading>
                        )}
                      </Box>
                    ) : null}
                    {detailDescription ? (
                      <Box>
                        {isLoading ? (
                          <Stack direction="column" gap={2}>
                            <Skeleton.Item width="95%" height="16px" />
                            <Skeleton.Item width="90%" height="16px" />
                            <Skeleton.Item width="90%" height="16px" />
                          </Stack>
                        ) : (
                          <RichText>{detailDescription}</RichText>
                        )}
                      </Box>
                    ) : null}
                    <ProgressDetails currentStatus={status ?? ''} statusOptions={statusOptions} />
                  </Box>

                  {progressLink ? progressLink : null}
                </Stack>
              </Box>
            }
            variableBlockPosition={'start'}
            variableBlockSpan={2}
          />
        ) : undefined
      }
      explanation={explanation}
      image={image}
    />
  );
}

